module.exports = __webpack_public_path__ + "images/wsj.png?8df2f9221e820dd5d0af8c46d207c9ad";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wsj.png
// module id = 57
// module chunks = 0